/**
 * A single charge inside a store's plan.
 *
 * Everything past `key` and `value` is optional: the backend does not send it yet, so a concept read
 * from the current contract keeps working and the extra columns render empty.
 */
export type PlanConcept = Readonly<{
  key: string;
  value: number;
  name: string | null;
  description: string | null;
  quantity: number | null;
  periodStart: string | null;
  periodEnd: string | null;
}>;

export type PlanConceptParams = {
  key: string;
  value: number;
  name?: string | null;
  description?: string | null;
  quantity?: number | null;
  periodStart?: string | null;
  periodEnd?: string | null;
};

/**
 * Creates a validated PlanConcept value object.
 *
 * @param params - Plan concept parameters
 * @returns Validated PlanConcept
 * @throws Error if key is empty
 */
export const createPlanConcept = (params: PlanConceptParams): PlanConcept => {
  if (!params.key?.trim()) {
    throw new Error('Plan concept key is required');
  }

  return Object.freeze({
    key: params.key,
    value: params.value,
    name: params.name ?? null,
    description: params.description ?? null,
    quantity: params.quantity ?? null,
    periodStart: params.periodStart ?? null,
    periodEnd: params.periodEnd ?? null,
  });
};
